import { forwardRef } from 'react';
import { getResponsiveAttributes } from '../internal/utils/getResponsiveAttributes.js';
import classes from './Stack.module.css.js';
import { clsx } from 'clsx';
import { BoxWithFallback } from '../internal/components/BoxWithFallback.js';
import { jsx } from 'react/jsx-runtime';

const Stack = /*#__PURE__*/forwardRef(({
  as,
  children,
  align = 'stretch',
  direction = 'vertical',
  gap,
  justify = 'start',
  padding = 'none',
  wrap = 'nowrap',
  className,
  ...rest
}, forwardedRef) => {
  return /*#__PURE__*/jsx(BoxWithFallback, {
    as: as,
    ref: forwardedRef,
    ...rest,
    className: clsx(className, classes.Stack),
    ...getResponsiveAttributes('gap', gap),
    ...getResponsiveAttributes('direction', direction),
    ...getResponsiveAttributes('align', align),
    ...getResponsiveAttributes('wrap', wrap),
    ...getResponsiveAttributes('justify', justify),
    ...getResponsiveAttributes('padding', padding),
    children: children
  });
});
const StackItem = /*#__PURE__*/forwardRef(({
  as,
  children,
  grow,
  className,
  ...rest
}, forwardedRef) => {
  return /*#__PURE__*/jsx(BoxWithFallback, {
    as: as,
    ref: forwardedRef,
    ...rest,
    className: clsx(className, classes.StackItem),
    ...getResponsiveAttributes('grow', grow),
    children: children
  });
});

export { Stack, StackItem };
